import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { AbstractTemplateBox } from './abstract-template-box';

@Component({
  selector: 'app-select-template-box',
  templateUrl: './select-template-box.component.html',
  styleUrl: './select-template-box.component.scss',
  encapsulation: ViewEncapsulation.Emulated
})
export class SelectTemplateBoxComponent extends AbstractTemplateBox implements OnInit {
  @Input() view: string = 'simplesign';
  
  async ngOnInit() {
    await this.initIntegration();
  }
}